<template>
  <div id="customer">
    <div class="feature mainWidth">
      <mu-row gutter class="feature_box">
        <mu-col width="50" tablet="50" desktop="50">
          <div class="feature_img">
            <img :src="$t('about.customer.foundImg')" alt="">
          </div>
        </mu-col>
        <mu-col width="50" tablet="50" desktop="50">
          <div class="feature_intro">
            <div class="feature_title">{{$t('about.customer.meritsTitle')}}</div>
            <mu-row gutter>
              <mu-col class="" width="100" tablet="50" desktop="50"  v-for="item in $t('about.customer.merits')" :key="item">
                <div class="merits">
                  <span class="merits_icon"></span><span class="merits_item">{{item}}</span>
                </div>
              </mu-col>
            </mu-row>

          </div>
        </mu-col>
      </mu-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){

    },
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #customer{
    padding-bottom: 60px;
    .feature_box{
      padding:100px 0px;
      overflow:hidden;
      background:#FFF;
      .feature_img{
        height:438px;
        float:right;
        margin-right:20px;
        >img{
          width:auto;
          height:inherit;
        }
      }
      .feature_intro{
        margin-left:20px;
        .feature_title{
          display:inline-block;
          min-width:90px;
          font-family: PingFangSC-Regular;
          font-size:24px;
          color: #3B3B3B;
          letter-spacing: 0;
          padding-bottom:20px;
          border-bottom:2px solid #6FA0FF;
          margin-bottom:20px;
        }
        .merits{
          .merits_icon{
            display: inline-block;
            width:13px;
            height:13px;
            background: url("../../../static/star-1.png") no-repeat center center;
            background-size: 100% 100%;
            margin-right:8px;
            vertical-align: middle;
          }
          .merits_item{
            display:inline-block;
            font-size: 14px;
            color: #333;
            letter-spacing: 0;
            line-height: 34px;
            /*font-weight: 600;*/
            vertical-align: middle;

          }
        }
      }
    }


  }

</style>




// WEBPACK FOOTER //
// src/page/childrens/customer.vue